var path = 'entity/alias/aliases-entity-select-panel.tpl.html';
var html = " <md-content flex layout=column> <section flex layout=column> <md-content flex class=md-padding layout=column> <div flex layout=row ng-repeat=\"(aliasId, entityAliasInfo) in vm.entityAliasesInfo\"> <md-input-container flex> <label>{{entityAliasInfo.alias}}</label> <md-select ng-model=entityAliasInfo.selectedId ng-change=\"vm.currentAliasEntityChanged(aliasId, entityAliasInfo.selectedId)\"> <md-option ng-repeat=\"resolvedEntity in entityAliasInfo.resolvedEntities\" ng-value=resolvedEntity.id> {{resolvedEntity.name}} </md-option> </md-select> </md-input-container> </div> </md-content> </section> </md-content> ";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/app/entity/alias/aliases-entity-select-panel.tpl.html
// module id = 1458
// module chunks = 1